import {useTranslation} from "react-i18next";
import {useForm, Yup} from "../forms/form";
import {Button, Form} from "react-bootstrap";
import {FormGroup} from "../components";
import Select from "../forms/inputs/Select";
import React, {useEffect, useState} from "react";
import styled from "styled-components";

const StyledButtonRow = styled.div`
  margin-top: 5px;
  display: flex;
  justify-content: end;
  button {
    margin-left: 5px;
  }
`

export default function VendorForm({vendor, setSubmitButtonProps, onSubmit, params, purposes = [], geomediaPurposes = [], geodataPurposes = []}) {
  const { t } = useTranslation();

  const [editable, setEditable] = useState(true)

  useEffect(() => {
    vendor && setEditable(vendor.editable)
  }, [vendor])

  const initialValues = {
    name: '',
    policyUrl: '',
    key: '',
    purposeIds: obj => obj ? buildPurposeIds(obj) : []
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required(),
    policyUrl: Yup.string().required(),
    key: Yup.string()
  })

  const { getInputProps, formProps, formData, handleInputChange } = useForm({
    defaultObject: vendor,
    initialValues: initialValues,
    validationSchema: validationSchema,
    setSubmitButtonProps: setSubmitButtonProps,
    preProcess: (data) => {
      const initialPurposeIds = vendor ? [...vendor.purposes, ...vendor.specialFeatures].filter(p => !p.removed).map(purposeValue) : []
      const newPurposeIds = data.purposeIds
      const addedPurposeIds = newPurposeIds.filter( p => !initialPurposeIds.includes(p))
      const deletedPurposeIds = initialPurposeIds.filter( p => !newPurposeIds.includes(p))
      return {...data, addedPurposeIds, deletedPurposeIds}
    },
    onAttributeChange: {
      name: {
        key: (value) => {
          return editable && !vendor ? value.toLowerCase().replaceAll(/[^a-z0-9]/g, '') : false
        }
      }
    },
    onSubmit: onSubmit,
  });

  function buildPurposeIds(obj = {purposes: [], specialFeatures: []}) {
    return [...obj.purposes, ...obj.specialFeatures].filter(el => !el.removed).map(purposeValue)
  }

  function purposeValue(purpose) {
    return `${purpose.type}|${purpose.id}`
  }

  function formattedPurposeOption(purpose) {
    return ({value: purposeValue(purpose), label: `[${t("cmp."+purpose.type)}] [${purpose.iabId || '-'}] - ${purpose.name}`})
  }

  const addGeoMediaPurposes = () => {
    handleInputChange([...formData.purposeIds, ...geomediaPurposes.map(purposeValue)], 'purposeIds')
  }

  const addGeoDataPurposes = () => {
    handleInputChange([...formData.purposeIds, ...geodataPurposes.map(purposeValue)], 'purposeIds')
  }

  return <Form {...formProps}>
    <FormGroup input="text" label={t("cmp.vendors.name")} {...getInputProps("name")} disabled={!editable}/>
    <FormGroup input="text" label={t("cmp.vendors.policyUrl")} {...getInputProps("policyUrl")} disabled={!editable}/>
    {!vendor?.iabId && <FormGroup input="text" label={t("cmp.vendors.key")} {...getInputProps("key")}/>}
    <FormGroup label={t("cmp.vendors.purposes")} {...getInputProps("purposeIds")}>
      <Select isMulti isClearable options={purposes.map(formattedPurposeOption)}/>
      <StyledButtonRow>
        <Button onClick={addGeoMediaPurposes}>Add Geomedia purposes</Button>
        <Button onClick={addGeoDataPurposes}>Add Geodata purposes</Button>
      </StyledButtonRow>
    </FormGroup>
  </Form>

}
